<template>

  <div class="singleImage grid grid__item_span-12 p0 m0">

    <img :src="item.project_single_image.url" :alt="item.project_single_image.alt" :title="item.project_single_image.title" />
 
  </div>

</template> 

<script>

import animateScroll from '../../assets/js/projectAnimation.js'
var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'SingleImage',
  props: [
    'item'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    animateElements () {
      animateScroll.animate()
    }
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      if (visible === true) {
        // console.log('YES')
        this.animateElements()
      } else {
        // console.log('no luck')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .singleImage {
    height: auto;
  }
  .singleImage img{
    width: 100%;
    height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/project/singleImage.vue